var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-overlay',{attrs:{"absolute":_vm.absolutePosition,"value":_vm.loading,"z-index":_vm.zIndex}},[_c('v-progress-circular',{style:(("max-height: " + _vm.maxHeight)),attrs:{"size":_vm.size,"indeterminate":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }